var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_18452)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10487_18452)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10487_18452)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.0019,
    height: 56.0019,
    rx: 28.0009,
    fill: "#CCCEFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0561,
    y: 29.3232,
    width: 17.7339,
    height: 4.51126,
    rx: 2.25563,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.466682
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10487_18452)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.84538,
    y: 47.1135,
    width: 33.7567,
    height: 35.779,
    rx: 16.8783,
    transform: "rotate(-16 6.84538 47.1135)",
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.466682
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9449,
    y: 37.879,
    width: 9.48921,
    height: 4.51126,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.466682
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1781,
    y: 37.6457,
    width: 9.02252,
    height: 6.22243,
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.767,
    y: 17.5005,
    width: 14.3116,
    height: 22.5563,
    rx: 7.1558,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.466682
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_10487_18452",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2246 43.7125C35.9187 46.1338 32.3189 48.0447 27.9231 48.0447C23.5529 48.0447 19.9694 46.1559 19.6273 43.7546C13.7735 45.4311 9.48926 50.823 9.48926 57.2155V67.7936H46.5127V57.2155C46.5127 50.7685 42.1551 45.3393 36.2246 43.7125Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2246 43.7125C35.9187 46.1338 32.3189 48.0447 27.9231 48.0447C23.5529 48.0447 19.9694 46.1559 19.6273 43.7546C13.7735 45.4311 9.48926 50.823 9.48926 57.2155V67.7936H46.5127V57.2155C46.5127 50.7685 42.1551 45.3393 36.2246 43.7125Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2246 43.7125L36.348 43.2625L35.829 43.1201L35.7616 43.654L36.2246 43.7125ZM19.6273 43.7546L20.0894 43.6888L20.0138 43.1585L19.4989 43.3059L19.6273 43.7546ZM9.48926 67.7936H9.02258V68.2603H9.48926V67.7936ZM46.5127 67.7936V68.2603H46.9794V67.7936H46.5127ZM35.7616 43.654C35.6361 44.647 34.8158 45.6258 33.3908 46.3733C31.9805 47.1131 30.0584 47.5781 27.9231 47.5781V48.5114C30.1836 48.5114 32.2593 48.0209 33.8243 47.1999C35.3746 46.3866 36.5071 45.1993 36.6876 43.771L35.7616 43.654ZM27.9231 47.5781C25.8004 47.5781 23.888 47.1185 22.48 46.3861C21.0573 45.6461 20.2299 44.6754 20.0894 43.6888L19.1653 43.8204C19.3668 45.2351 20.5022 46.4095 22.0493 47.2142C23.6111 48.0265 25.6757 48.5114 27.9231 48.5114V47.5781ZM9.95594 57.2155C9.95594 51.0368 14.0969 45.824 19.7558 44.2032L19.4989 43.3059C13.4502 45.0383 9.02258 50.6092 9.02258 57.2155H9.95594ZM9.95594 67.7936V57.2155H9.02258V67.7936H9.95594ZM46.5127 67.327H9.48926V68.2603H46.5127V67.327ZM46.046 57.2155V67.7936H46.9794V57.2155H46.046ZM36.1011 44.1626C41.8342 45.7352 46.046 50.9841 46.046 57.2155H46.9794C46.9794 50.5529 42.476 44.9434 36.348 43.2625L36.1011 44.1626Z",
    fill: "#111111",
    mask: "url(#path-9-inside-1_10487_18452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4258 24.8575C36.4258 18.845 33.109 14.7783 29.0689 14.7783C23.893 14.7783 18.6196 16.7198 18.6196 25.9003C18.6196 28.1718 18.7888 29.8646 20.1449 31.1121C20.3004 31.2553 20.6999 31.5673 20.6272 31.442C20.3642 28.9874 22.269 27.7439 25.1228 25.9003C26.6378 24.9217 29.7896 23.1008 30.9563 22.1674C31.8292 22.662 33.5795 24.0676 34.0683 24.9056C34.3305 25.355 34.7515 26.8951 35.0391 28.6928C35.9796 27.5632 36.4258 26.4328 36.4258 24.8575Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.597657
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1974 21.4419C31.3959 20.3552 33.1888 17.8751 33.0738 16.2643",
    stroke: "#111111",
    strokeWidth: 0.597657
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 54.5019,
    height: 54.5019,
    rx: 27.2509,
    stroke: "white",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10487_18452",
    x: -20,
    y: -10,
    width: 96.0018,
    height: 96.0019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.113725 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10487_18452"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10487_18452",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_18452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10487_18452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.0019,
    height: 56.0019,
    rx: 28.0009,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10487_18452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2234,
    height: 49.7794,
    fill: "white",
    transform: "translate(10.8893 3.73346)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric11);
export default __webpack_public_path__ + "static/media/Generic 11.ff572750effc46a229c7bc7690b01c32.svg";
export { ForwardRef as ReactComponent };